import Unit from "@/src/utils/constants/units";

export const highlighterQuickInfoLine = (squareMeter, estateType, quickInfo) => {
  let grossSquare = null;
  const estateTypeName = estateType || "";
  const quickInfos = quickInfo || [];
  if (typeof squareMeter === "string") {
    grossSquare = squareMeter.includes(`${Unit.M2.name}`) ? squareMeter : `${squareMeter} ${Unit.M2.name}`;
  } else {
    grossSquare = squareMeter ? `${squareMeter} ${Unit.M2.name}` : null;
  }

  const quickInfoList = [
    {
      key: "estate_type",
      name: "Kategori",
      value: estateTypeName,
    },
    ...quickInfos,
  ];

  const isIncludesSquare = quickInfoList.some((quickInfoItem) => quickInfoItem.key === "square");

  if ((!quickInfoList || quickInfoList.length === 0) && !grossSquare) return [];
  if (!isIncludesSquare && grossSquare) {
    const groosSquareIndex = quickInfoList.findIndex((qi) => qi.key === "gross_square");
    if (groosSquareIndex === -1) {
      quickInfoList.push({
        key: "gross_square",
        name: "Brüt Alan",
        unit: null,
        value: grossSquare,
      });
    } else {
      quickInfoList[groosSquareIndex].value = grossSquare;
    }
  }

  return quickInfoList;
};
